// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_f1-0";